import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { type IIconsVector } from 'shared/ui'
import { type RowGroupInbox } from 'entities/Inbox/model/Table/RowGroupInbox'
import { useInboxesViewContext } from 'pages/settings/pages/inboxes/context/inboxesViewContext'
import { InboxesTable } from 'pages/settings/pages/inboxes/pages/inboxesView/ui/InboxesTable/InboxesTable'
import { getGroupInboxesColumns } from './columns'

export const GroupInboxesTab = observer(() => {
  const { groupInboxesViewStore, isManageOrganizationInboxes } = useInboxesViewContext()
  const {
    tableStore,
    loading,
    search,
    setSearch,
    sortedRows,
    handleDeleteGroupInboxModal,
    groupInboxFormStore,
  } = groupInboxesViewStore
  const { handleEditGroupInbox } = groupInboxFormStore

  useEffect(() => {
    return () => {
      setSearch('')
    }
  }, [])

  const columns = useMemo(() => getGroupInboxesColumns(), [])
  const getRowActions = (item: RowGroupInbox) => {
    return [
      {
        text: 'Edit',
        icon: 'edit' as IIconsVector,
        onAction: () => {
          handleEditGroupInbox(item.origin)
        },
      },
      {
        text: 'Delete',
        icon: 'delete' as IIconsVector,
        onAction: () => {
          handleDeleteGroupInboxModal(item.id)
        },
      },
    ]
  }

  const rows = sortedRows.map((item) => {
    item.setActionsProps({
      actions: isManageOrganizationInboxes ? getRowActions(item) : [],
    })

    return item
  })

  return (
    <InboxesTable<RowGroupInbox>
      rows={rows}
      columns={columns}
      loading={loading}
      setSearch={setSearch}
      search={search}
      tableStore={tableStore}
    />
  )
})
